//icons.tsx — inline SVG glyphs; no icon font or sprite to load

interface IconProps {
	size?: number
}

//Vertices solved so the stroked bounding box centres on 12.6 — a right-pointing triangle
//needs that half-pixel bias right of true centre to look centred in a circle. Rounded joins
//come from stroking the same colour as the fill rather than from a hand-built path.
export const PlayIcon = ({ size = 24 }: IconProps) => (
	<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
		<path
			d="M8.2 6.9 17 12l-8.8 5.1Z"
			fill="currentColor"
			stroke="currentColor"
			strokeWidth="3"
			strokeLinejoin="round"
			strokeLinecap="round"
		/>
	</svg>
)

export const StopIcon = ({ size = 24 }: IconProps) => (
	<svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
		{/* Slightly inset of the triangle's visual height so the two states feel equal weight. */}
		<rect x="5.9" y="5.9" width="12.2" height="12.2" rx="3.3" fill="currentColor" />
	</svg>
)

export const GearIcon = ({ size = 19 }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<circle cx="12" cy="12" r="3" />
		<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" />
	</svg>
)

export const CheckIcon = ({ size = 12 }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="3.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d="M20 6 9 17l-5-5" />
	</svg>
)

export const ChevronIcon = ({ direction, size = 20 }: IconProps & { direction: 'left' | 'right' }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2.4"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d={direction === 'left' ? 'm15 18-6-6 6-6' : 'm9 18 6-6-6-6'} />
	</svg>
)
